import {
    type AddSubscriptionResponse,
    logSentryError,
    type PostOrdergrooveAddSubscription,
    useAddAutoshipSubscription as useSharedAddAutoshipSubscription,
} from '@libs/common-next';

import { SentryErrors } from '@/shared/sentry';

export type { PostOrdergrooveAddSubscription } from '@libs/common-next';

type UseAddAutoshipSubscriptionParams = {
    onError?: (error: Error) => void;
    onSuccess?: (response: AddSubscriptionResponse, variables: PostOrdergrooveAddSubscription) => void;
};

/**
 * PDP wrapper around the shared mutation: the shared hook does not report to Sentry,
 * so the PDP logs failures under its own `AddAutoshipSubscriptionFailed` key.
 */
export function useAddAutoshipSubscription({ onError, onSuccess }: UseAddAutoshipSubscriptionParams = {}) {
    return useSharedAddAutoshipSubscription({
        onSuccess,
        onError: error => {
            logSentryError(error, SentryErrors.AutoshipAPI.AddAutoshipSubscriptionFailed);
            onError?.(error);
        },
    });
}
